import Api, { put } from "./Api";

export default class WebhookApi extends Api{
    constructor() {
        super(process.env.REACT_APP_WEBHOOK_ENDPOINT);
    }
    updateWebhook = (params) => put(this.baseUrl, params);
}